import React from 'react'
import { ThemeProvider } from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import { ErrorMessage, SubLabel, RequirementList, Requirement } from './styles'

const themes = {
  invalid: {
    color: color.SILVER,
    bulletColor: color.STONE,
  },
  valid: {
    color: color.AQUAMARINE,
    bulletColor: color.SCOOTER,
  },
}

export default Component => props => {
  const {
    showrequirements,
    subLabel,
    meta: { touched, error } = {},
    requirementsStyle = {},
    subLabelStyle = {},
  } = props

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <Component {...props} />

      {/* the subLabel is grey text that goes under the input */}
      {((!error && touched) || !touched) && subLabel && (
        <SubLabel style={subLabelStyle}>{subLabel}</SubLabel>
      )}

      {/* the error text is red text that will replace the instructions
          when there is an error. */}
      {!showrequirements && touched && error && (
        <ErrorMessage>
          {typeof error === 'string' ? error : Object.values(error)[0]}
        </ErrorMessage>
      )}

      {/* Some fields, like password, have a list of requirements that get
          marked off as they are met by the users input. We can show this
          for any field, but mostly we use it for passwords. */}
      {showrequirements && (
        <RequirementList style={requirementsStyle}>
          {props.validators &&
            props.validators.map((validator, idx) => {
              // this basically prevents the required validator from
              // showing in the list of requirements
              if (validator.label === 'This is a required field') {
                return null
              }
              return (
                <ThemeProvider
                  key={idx}
                  theme={
                    validator(props.input.value) ? themes.invalid : themes.valid
                  }
                >
                  <Requirement>{validator.label}</Requirement>
                </ThemeProvider>
              )
            })}
        </RequirementList>
      )}
    </div>
  )
}
